export default __webpack_public_path__ + "static/media/warning-tape.846082e6.png";